import { AdvancedMarker, InfoWindow, useAdvancedMarkerRef } from "@vis.gl/react-google-maps";
import {useCallback, useEffect} from "react";
import {useMapCluster} from "./map-cluster-provider.jsx";

const MarkerWithInfoWindow = ({ position, children, infoWindowContent, isOpen, onToggleClick, onClose }) => {
  const [markerRef, marker] = useAdvancedMarkerRef();

  const handleMarkerClick = useCallback(() => {
    onToggleClick();
  }, [onToggleClick]);

  return (
    <>
      <AdvancedMarker
        ref={markerRef}
        position={position}
        onClick={handleMarkerClick}
      >
        {children}
      </AdvancedMarker>

      {isOpen && (
        <InfoWindow anchor={marker} headerDisabled={true} onCloseClick={onClose}>
          {infoWindowContent}
        </InfoWindow>
      )}
    </>
  );
};

export default MarkerWithInfoWindow;
